export default __webpack_public_path__ + "static/media/100_39297.59cfaa65.jpg";